import request from "@/utils/request";

export async function listByCategory(categoryName) {
  const response = await request.get(`/products?category=${categoryName}`);
  return response.data.data;
}

export async function getById(id) {
  return (await request.get(`/products/${id}`)).data.data;
}

export async function listActive() {
  return (await request.get('/products/active')).data.data.products;
}